(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-cta"] && !Shopify.designMode) return;
  try {
    
  if (typeof lucide !== 'undefined') {
    lucide.createIcons();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lead-form-cta-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DESKTOP = '(min-width: 768px)';

    function ready(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    ready(function () {
      document.querySelectorAll('[data-pp-lead-cta-root]').forEach(function (root) {
        var bar = root.querySelector('[data-pp-lead-cta]');
        if (!bar) return;

        var mq = window.matchMedia(DESKTOP);

        function setFixed(fixed) {
          if (!mq.matches) {
            bar.classList.remove('is-fixed');
            document.body.classList.remove('pp-lead-cta-is-fixed');
            root.style.minHeight = '';
            return;
          }

          if (fixed) {
            if (!bar.classList.contains('is-fixed')) {
              root.style.minHeight = bar.offsetHeight + 'px';
            }
            bar.classList.add('is-fixed');
            document.body.classList.add('pp-lead-cta-is-fixed');
            return;
          }

          bar.classList.remove('is-fixed');
          document.body.classList.remove('pp-lead-cta-is-fixed');
          root.style.minHeight = '';
        }

        var observer = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          setFixed(!entry.isIntersecting);
        }, { threshold: 0 });

        function bind() {
          observer.disconnect();
          if (mq.matches) {
            root.style.minHeight = bar.offsetHeight + 'px';
            observer.observe(root);
          } else {
            setFixed(false);
          }
        }

        if (mq.addEventListener) {
          mq.addEventListener('change', bind);
        } else if (mq.addListener) {
          mq.addListener(bind);
        }

        bind();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lead-form-popup-apps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FORM_SKIN = [
      ':host{--inline-container-min-height:auto!important;--app-embed-padding-x:0px!important;--app-embed-padding-y:0px!important;--forms-padding-top:0px!important;--forms-padding-right:0px!important;--forms-padding-bottom:0px!important;--forms-padding-left:0px!important;--container-max-w:100%!important;--inline-container-max-width:100%!important;--form-field-padding:12px!important;--form-field-padding-top:12px!important;--form-field-padding-bottom:12px!important;}',
      '[data-form-root],[class*="_formContainer"],[class*="_inline"],[class*="_grid"],[class*="_gridItem"]{overflow:visible!important;max-width:100%!important;width:100%!important;height:auto!important;}',
      'section[role="dialog"]{position:relative!important;inset:auto!important;height:auto!important;width:100%!important;max-height:none!important;}',
      '[class*="_formHeader"]{display:none!important;margin:0!important;}',
      'form{gap:14px!important;padding:0!important;}',
      '[class*="_formFieldContainer"]{position:relative!important;display:flex!important;flex-direction:column-reverse!important;gap:6px!important;}',
      'label[id^="label-"]{position:static!important;top:auto!important;left:auto!important;transform:none!important;max-width:none!important;color:#4B1D7A!important;font-size:12px!important;font-weight:700!important;line-height:1.2!important;pointer-events:none!important;}',
      'input[class*="_formInputField"],input[class*="_formPhoneInputField"]{padding:12px 14px!important;}',
      '[class*="_formPhoneInputContainer"]{display:grid!important;grid-template-columns:90px minmax(0,1fr)!important;grid-template-rows:auto auto!important;gap:6px 8px!important;align-items:stretch!important;}',
      '[class*="_formPhoneInputContainer"]>[class*="_formFieldContainer"]{display:contents!important;}',
      '[class*="_formPhoneInputContainer"] label[id^="label-"]{grid-row:1!important;grid-column:1/-1!important;}',
      '[class*="_formPhoneInputContainer"] .phone-country-selector{grid-row:2!important;grid-column:1!important;}',
      '[class*="_formPhoneInputContainer"] input{grid-row:2!important;grid-column:2!important;}',
      '[class*="_formDisclaimer"]{margin-top:4px!important;}'
    ].join('');

    function ready(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    var STORAGE_TTL_MS = 24 * 60 * 60 * 1000;

    function showSuccess(dialog) {
      var formView = dialog.querySelector('[data-pp-lead-form-view]');
      var successView = dialog.querySelector('[data-pp-lead-success-view]');
      if (formView) formView.hidden = true;
      if (successView) successView.hidden = false;
    }

    function readStoredAt(key) {
      try {
        var raw = window.localStorage.getItem(key);
        if (!raw) return 0;
        if (raw === '1') {
          var migrated = Date.now();
          window.localStorage.setItem(key, JSON.stringify({ at: migrated }));
          return migrated;
        }
        var data = JSON.parse(raw);
        return data && data.at ? Number(data.at) : 0;
      } catch (err) {
        return 0;
      }
    }

    function hasRecentSuccess(key) {
      if (!key) return false;
      var at = readStoredAt(key);
      if (!at) return false;
      if (Date.now() - at > STORAGE_TTL_MS) {
        try {
          window.localStorage.removeItem(key);
        } catch (err) {}
        return false;
      }
      return true;
    }

    function persistSuccess(key) {
      if (!key) return;
      try {
        window.localStorage.setItem(key, JSON.stringify({ at: Date.now() }));
      } catch (err) {}
    }

    function skinEmbed(embed) {
      var sr = embed.shadowRoot;
      if (!sr) return false;

      if (!sr.getElementById('pp-lead-form-skin')) {
        var style = document.createElement('style');
        style.id = 'pp-lead-form-skin';
        style.textContent = FORM_SKIN;
        sr.appendChild(style);
      }

      sr.querySelectorAll('label').forEach(function (label) {
        label.style.removeProperty('top');
      });

      return true;
    }

    function watchLayout(embed) {
      if (embed.getAttribute('data-pp-lead-skinned') === '1') return;
      if (!skinEmbed(embed)) return;
      embed.setAttribute('data-pp-lead-skinned', '1');

      var sr = embed.shadowRoot;
      var observer = new MutationObserver(function () {
        skinEmbed(embed);
      });
      observer.observe(sr, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    function relayoutForms(dialog) {
      dialog.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
        watchLayout(embed);
        skinEmbed(embed);
      });
    }

    function openDialog(dialog) {
      if (!dialog) return;
      var key = dialog.getAttribute('data-storage-key');
      try {
        if (hasRecentSuccess(key)) {
          showSuccess(dialog);
        }
      } catch (err) {}
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      window.requestAnimationFrame(function () {
        relayoutForms(dialog);
        window.setTimeout(function () {
          relayoutForms(dialog);
        }, 80);
        window.setTimeout(function () {
          relayoutForms(dialog);
        }, 250);
      });
    }

    function closeDialog(dialog) {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    function markSubmitted(dialog) {
      if (dialog.getAttribute('data-pp-lead-complete') === '1') return;
      dialog.setAttribute('data-pp-lead-complete', '1');
      persistSuccess(dialog.getAttribute('data-storage-key'));
      showSuccess(dialog);
    }

    function isFormsError(embed) {
      var sr = embed.shadowRoot;
      if (!sr) return false;
      if (sr.querySelector('[data-current-step="error"]')) return true;
      if (sr.querySelector('[data-testid="banner-error"]')) return true;
      if (sr.querySelector('[data-testid="banner-failure"]')) return true;
      if (sr.querySelector('[aria-invalid="true"]')) return true;
      if (sr.querySelector('[class*="_withError"]')) return true;
      return false;
    }

    function isFormsSuccess(embed) {
      var sr = embed.shadowRoot;
      if (!sr) return false;
      if (isFormsError(embed)) return false;
      if (sr.querySelector('[data-current-step="success"]')) return true;
      if (sr.querySelector('[data-testid="banner-success"]')) return true;
      return false;
    }

    function watchEmbed(dialog, embed) {
      watchLayout(embed);
      if (isFormsSuccess(embed)) {
        markSubmitted(dialog);
        return;
      }

      var sr = embed.shadowRoot;
      if (!sr) return;

      var observer = new MutationObserver(function () {
        if (isFormsError(embed)) return;
        if (isFormsSuccess(embed)) {
          markSubmitted(dialog);
          observer.disconnect();
        }
      });

      observer.observe(sr, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-current-step', 'class', 'aria-invalid']
      });
    }

    function attachFormsWatchers(dialog) {
      function bind() {
        dialog.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
          if (embed.shadowRoot) {
            watchEmbed(dialog, embed);
            return;
          }
          customElements.whenDefined('shopify-forms-embed').then(function () {
            window.setTimeout(function () {
              watchEmbed(dialog, embed);
              relayoutForms(dialog);
            }, 50);
          }).catch(function () {});
        });
      }

      bind();
      var tries = 0;
      var timer = window.setInterval(function () {
        tries += 1;
        if (dialog.querySelector('shopify-forms-embed') && dialog.querySelector('shopify-forms-embed').shadowRoot) {
          window.clearInterval(timer);
          bind();
          relayoutForms(dialog);
        } else if (tries > 40) {
          window.clearInterval(timer);
        }
      }, 150);
    }

    ready(function () {
      var dialogs = document.querySelectorAll('[data-pp-lead-dialog="forms"]');
      if (!dialogs.length) return;

      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-pp-lead-open]');
        if (opener) {
          event.preventDefault();
          openDialog(dialogs[0]);
          return;
        }

        var closer = event.target.closest('[data-pp-lead-close]');
        if (closer) {
          var dialog = closer.closest('[data-pp-lead-dialog="forms"]');
          if (!dialog) return;
          event.preventDefault();
          closeDialog(dialog);
        }
      });

      dialogs.forEach(function (dialog) {
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeDialog(dialog);
        });
        attachFormsWatchers(dialog);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lead-form-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function ready(fn) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
      } else {
        fn();
      }
    }

    function showSuccess(dialog) {
      var formView = dialog.querySelector('[data-pp-lead-form-view]');
      var successView = dialog.querySelector('[data-pp-lead-success-view]');
      if (formView) formView.hidden = true;
      if (successView) successView.hidden = false;
    }

    function openDialog(dialog) {
      if (!dialog) return;
      var key = dialog.getAttribute('data-storage-key');
      try {
        if (key && window.localStorage.getItem(key) === '1') {
          showSuccess(dialog);
        }
      } catch (err) {}
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    }

    function closeDialog(dialog) {
      if (!dialog) return;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    function validateForm(form, errorBox) {
      var name = form.querySelector('[name="contact[name]"]');
      var email = form.querySelector('[name="contact[email]"]');
      var phone = form.querySelector('[name="contact[phone]"]');
      var valid = true;
      var message = '';

      form.querySelectorAll('input.is-invalid').forEach(function (input) {
        input.classList.remove('is-invalid');
      });

      if (name && !name.value.trim()) {
        name.classList.add('is-invalid');
        valid = false;
        message = 'Por favor escribe tu nombre.';
      }

      if (valid && email) {
        var emailValue = email.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
          email.classList.add('is-invalid');
          valid = false;
          message = 'Por favor ingresa un correo válido.';
        }
      }

      if (valid && phone) {
        var digits = phone.value.replace(/\D/g, '');
        if (digits.length < 10) {
          phone.classList.add('is-invalid');
          valid = false;
          message = 'Por favor ingresa un WhatsApp válido (mínimo 10 dígitos).';
        }
      }

      if (errorBox) {
        if (valid) {
          errorBox.hidden = true;
          errorBox.textContent = '';
        } else {
          errorBox.hidden = false;
          errorBox.textContent = message;
        }
      }

      return valid;
    }

    ready(function () {
      var dialogs = document.querySelectorAll('[data-pp-lead-dialog="contact"]');
      if (!dialogs.length) return;

      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-pp-lead-open]');
        if (opener) {
          if (document.querySelector('[data-pp-lead-dialog="forms"]')) return;
          event.preventDefault();
          openDialog(dialogs[0]);
          return;
        }

        var closer = event.target.closest('[data-pp-lead-close]');
        if (closer) {
          var dialog = closer.closest('[data-pp-lead-dialog="contact"]');
          if (!dialog) return;
          event.preventDefault();
          closeDialog(dialog);
        }
      });

      dialogs.forEach(function (dialog) {
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeDialog(dialog);
        });

        var form = dialog.querySelector('form');
        if (!form) return;
        var errorBox = dialog.querySelector('[data-pp-lead-error]');
        var submitBtn = dialog.querySelector('[data-pp-lead-submit]');

        form.addEventListener('submit', function (event) {
          event.preventDefault();
          if (!validateForm(form, errorBox)) return;

          var original = submitBtn ? submitBtn.textContent : '';
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Enviando...';
          }

          fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'text/html' }
          })
            .then(function (response) {
              if (!response.ok) throw new Error('network');
              var key = dialog.getAttribute('data-storage-key');
              try {
                if (key) window.localStorage.setItem(key, '1');
              } catch (err) {}
              showSuccess(dialog);
            })
            .catch(function () {
              if (errorBox) {
                errorBox.hidden = false;
                errorBox.textContent = 'Hubo un error al enviar el formulario. Por favor intenta de nuevo.';
              }
            })
            .finally(function () {
              if (submitBtn) {
                submitBtn.disabled = false;
                submitBtn.textContent = original;
              }
            });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["use-cases"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatCount(value) {
      if (value >= 1000000) {
        var millions = value / 1000000;
        return (Math.round(millions * 10) / 10).toString().replace(/\.0$/, '') + 'M';
      }
      return Math.round(value).toLocaleString('es-MX');
    }

    function animateCount(el, target) {
      var duration = 1100;
      var start = null;
      function frame(now) {
        if (!start) start = now;
        var t = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = formatCount(target * eased);
        if (t < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function findSection(root) {
      if (!root) return document.querySelector('.pp-use-cases');
      if (root.classList && root.classList.contains('pp-use-cases')) return root;
      if (root.querySelector) return root.querySelector('.pp-use-cases');
      return null;
    }

    function teardown(section) {
      if (!section || !section._ppUseCasesObserver) return;
      section._ppUseCasesObserver.disconnect();
      section._ppUseCasesObserver = null;
    }

    function initUseCases(root) {
      var section = findSection(root);
      if (!section) return;

      teardown(section);

      var tiles = section.querySelectorAll('.pp-use-case');
      tiles.forEach(function (tile) {
        tile.classList.remove('is-visible');
        var pulse = tile.querySelector('.pp-viz-pulse');
        if (pulse) pulse.classList.remove('is-settled');
        var num = tile.querySelector('.pp-use-case__num[data-count-to]');
        if (num) num.textContent = '0';
      });

      function reveal(tile) {
        if (tile.classList.contains('is-visible')) return;
        tile.classList.add('is-visible');
        var num = tile.querySelector('.pp-use-case__num[data-count-to]');
        if (num) {
          var target = parseFloat(num.getAttribute('data-count-to'));
          if (!isNaN(target)) animateCount(num, target);
        }
        var pulse = tile.querySelector('.pp-viz-pulse');
        if (pulse) {
          var settle = function (event) {
            if (event.animationName !== 'pp-ping') return;
            pulse.classList.add('is-settled');
            pulse.removeEventListener('animationend', settle);
          };
          pulse.addEventListener('animationend', settle);
        }
      }

      if (!('IntersectionObserver' in window)) {
        tiles.forEach(reveal);
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          io.unobserve(entry.target);
        });
      }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' });

      tiles.forEach(function (tile) {
        io.observe(tile);
      });
      section._ppUseCasesObserver = io;
    }

    function onSectionEvent(event) {
      var root = event.target;
      if (!root || !findSection(root)) return;
      if (event.type === 'shopify:section:unload') {
        teardown(findSection(root));
        return;
      }
      initUseCases(root);
    }

    function boot() {
      initUseCases(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', onSectionEvent);
    document.addEventListener('shopify:section:unload', onSectionEvent);
    document.addEventListener('shopify:section:reorder', onSectionEvent);
    document.addEventListener('shopify:section:select', onSectionEvent);
  })();

  } catch(e) { console.error(e); }
})();
})();
